<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pGHgOy/tc-custom/9781455619788.jpg?1700958170479" alt="This image is the cover for the book Desperadoes of the Ozarks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Desperadoes of the Ozarks
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning author of <i>The Two Civil War Battles of Newtonia</i> “mine[s] the rich vein of bad men—and succeeds because of solid research.” —Fred Pfitser, editor, <i>Ozarks Mountaineer</i></b><br/><br/>This collection of events carries readers through an era of bootlegging, highway robbery, and vigilante courts. From the cow town of Baxter Springs, Kansas, to the booming mining camp of Granby, Missouri, the Ozarks were a magnet for lawlessness. Though some stories contain gory details, the author’s intention in narrating these events is not to pay tribute to the likes of the Tri-State Terror, Bloody Britton, or the Missouri Kid. Instead Larry Wood aspires to come to terms with the region’s violent past, learn from it, and move forward.<br/><br/>Among tales of desperate characters and brutal murders is a strengthening of law and order. As the area’s criminals wreak havoc, the Ozarks become the staging area for the last public hanging in the United States and the FBI’s first killing of a criminal. Each chapter is filled with the grisly excitement of flying bullets and mob lynchings as vengeance is dealt by the betrayed, but the book also captures the changes made to protect law-abiding citizens.<br/><br/><b>“Full of damnable acts, but they make for some darn interesting reading.” —<i>HistoryNet</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Wood
      </h2>
      
      <p class="authorDescription body article">Award-winning author Larry Wood is an avid writer with a strong passion for the Civil War and Ozarks history. In addition to penning several books on these subjects, he has contributed articles to publications such as Show Me: the Ozarks Magazine, the Ozarks Mountaineer, Missouri Life, and the Ozarks Reader. Wood is a member of the Joplin Writers Guild, Missouri Writers’ Guild, the Ozarks Writers League, and the Joplin Genealogy Society. The author of Ozarks Gunfights and Other Notorious Incidents, also from Pelican, Wood lives in Joplin, Missouri</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fcc5980